import { FC } from 'react'

import Portal from '@/components/portal'
import { composeClasses } from '@/utils/compose-classes'
export interface OverlayProps {
  children?: React.ReactNode
  className?: string
  renderType?: 'portal' | 'normal'
  show?: boolean
  onClose?: () => void
}

export const Overlay: FC<OverlayProps> = ({
  children,
  renderType = 'portal',
  className = '',
  show,
  onClose = () => {}
}) => {
  if (!show) {
    return null
  }

  if (renderType === 'normal') {
    return (
      <div
        className={composeClasses(
          'fixed top-0 left-0 bg-overlay-dark w-full h-full backdrop-blur-5 z-50',
          className
        )}
        onClick={onClose}
      >
        <div
          onClick={(e) => {
            e.stopPropagation()
          }}
        >
          {children}
        </div>
      </div>
    )
  }

  return (
    <Portal>
      <div
        className={composeClasses(
          'fixed top-0 left-0 bg-overlay-dark w-full h-full backdrop-blur-5 z-50',
          className
        )}
        onClick={onClose}
      >
        <div
          onClick={(e) => {
            e.stopPropagation()
          }}
        >
          {children}
        </div>
      </div>
    </Portal>
  )
}

export default Overlay
